import { Box, Button, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/userContext";
import { SETTINGS_PAGE } from "../../routes";

const InitializationFailedPage = () => {
  const { initializeUserAsync, initializationError } = useUser();
  const navigate = useNavigate();

  const handleRetryAsync = async () => {
    const user = await initializeUserAsync(true);
    if (user) {
      navigate(SETTINGS_PAGE);
    }
  };

  return (
    <Flex direction="column" align="center" justify="center" height="100vh" bg="secondary.800">
      <Box
        bg="secondary.900"
        p={6}
        boxShadow="md"
        borderRadius="lg"
        textAlign="center"
        minW="400px"
      >
        <VStack spacing={4}>
          <Heading size="lg">Initialization Failed</Heading>
          <Text>
            We were unable to initialize your user information. Please try again or contact support
            if the problem persists.
          </Text>
          {initializationError ? <Text color="orange.300">{initializationError}</Text> : null}
          <Button colorScheme="primary" onClick={handleRetryAsync}>
            Retry
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default InitializationFailedPage;
